var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SimpleTable',{attrs:{"data":_vm.tableData.filter(function (x) { return x.readonly; }),"columns":_vm.tableColumns},scopedSlots:_vm._u([_vm._l((_vm.nutrients),function(nutrient,i){return {key:nutrient,fn:function(ref){
var row = ref.row;
return [_c('ProbingResult',{key:nutrient,attrs:{"geometry-id":row.id,"nutrient":nutrient}})]}}}),{key:"soilSubType",fn:function(ref){
var row = ref.row;
return [_c('ProbingResultSoilSubType',{attrs:{"result":_vm.results[row.id].soilSubType}})]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }